import { call } from 'redux-saga/effects';
import { request } from '@wix/da-http-client/pkg/request';
import { getBackgrounds } from './_fixtures';
export function* doFetchBackgrounds(offset, limit) {
    const params = {
        offset,
        limit
    };
    const result = yield call(request, {
        method: 'get',
        url: '/deviation/backgrounds',
        params
    }, ()=>{
        return {
            results: getBackgrounds(),
            hasMore: false
        };
    });
    return result;
}
export function* doSetBackground(deviationid, backgroundid) {
    const data = {
        deviationid,
        backgroundid
    };
    const result = yield call(request, {
        method: 'post',
        url: '/deviation/set_background',
        data
    }, ()=>{
        return {
            success: true
        };
    });
    return result;
}
